/**
 * Functions for sort the list alphabetical order. If it has 'All Sites' always put it in the top
 */

export const alphabeticalSort = (arr) => {
  return arr.sort((item1, item2) => {
    if (item1 === "All Sites") {
      return -1; // 'All Sites' comes before any other item
    }
    if (item2 === "All Sites") {
      return 1; // Any other item comes after 'All Sites'
    }
    return item1.localeCompare(item2); // Otherwise, sort alphabetically
  });
};
